// extracted by mini-css-extract-plugin
module.exports =  {"trigger":"EorTooltip-module_trigger_fddc0"};